<!--审核专家出库申请弹框-->
<template>
  <a-modal width="90vw"
           centered
           :footer="false"
           :closable="false"
           :visible="modalVisible"
           :destroyOnClose="true">
    <div style="margin: -24px">
      <expert-info-detail-component :expertInfo="expertInfo"
                                    :showState="true"
                                    :showDetail="true">
        <template slot="content">
          <div class="zjmp_t3">
            <!-- 正常-->
            <div>入库日期：{{ expertInfo.addDate | dateFormat }}</div>
          </div>
          <div class="zjmp_t3">
            申请出库日期：<div>{{expertOutApplyFor.applyForDate | dateFormat}}</div>
          </div>
          <div class="zjmp_t3">
            申请出库理由：<div>{{expertOutApplyFor.outReason}}</div>
          </div>
          <div v-if="readonly">
            <div class="zjmp_t3">
              审核人：<div>{{ pendingAuditApplyForData.auditUserName }}</div>
            </div>
            <div class="zjmp_t3">
              审核时间：<div>{{ pendingAuditApplyForData.auditDate | dateFormat }}</div>
            </div>
            <div class="zjmp_t3">
              审核结果：<a-tag :color="AuditStateEnum.getValOrCol(pendingAuditApplyForData.auditState).color">{{ AuditStateEnum.getValOrCol(pendingAuditApplyForData.auditState).value }}</a-tag>
            </div>
            <div class="zjmp_t3"
                 v-if="pendingAuditApplyForData.auditState == AuditStateEnum.REFUSE[0]">
              废弃原因：<div>{{ pendingAuditApplyForData.auditFailReason }}</div>
            </div>
          </div>
          <div v-else>
            <a-form-model ref="auditForm"
                          :model="pendingAuditApplyForData"
                          :rules="rules"
                          :label-col="labelCol"
                          :wrapper-col="wrapperCol">
              <a-form-model-item label="是否同意"
                                 prop="auditState">
                <a-radio-group v-model="pendingAuditApplyForData.auditState">
                  <a-radio value="1">同意出库</a-radio>
                  <a-radio value="2">废弃</a-radio>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item label="废弃原因"
                                 prop="auditFailReason"
                                 v-if="pendingAuditApplyForData.auditState==AuditStateEnum.REFUSE[0]">
                <a-input v-model="pendingAuditApplyForData.auditFailReason"
                         placeholder="可填写废弃原因"
                         type="textarea"
                         :auto-size="{ minRows: 4 }" />
              </a-form-model-item>
            </a-form-model>
            <a-row :gutter="[12, 8]"
                   type="flex"
                   justify="center">
              <a-col :span="12">
                <a-button :loading="submitLoading"
                          @click="onSubmitApplyFor"
                          type="primary"
                          block>提交</a-button>
              </a-col>
            </a-row>
          </div>
        </template>
        <template slot="action">
          <a-button type="danger"
                    @click="onClose()">
            <a-icon type="close" />
          </a-button>
        </template>
      </expert-info-detail-component>
    </div>
  </a-modal>
</template>

<script>
import ExpertInfoDetailComponent from '@epp/expertmain/expertInfo/ExpertInfoDetailComponent'
import { GetPendingAuditApplyForById, SubmitAuditApplyFor } from '@/epp/expertmain/pendingauditapplyfor/api/ApplyForApi'
import { ExpertState } from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'
import { AuditStateEnum } from '@/epp/expertmain/pendingauditapplyfor/util/ApplyForUtil'

export default {
  name: 'AuditExpertStorageApplyFor',
  components: {
    ExpertInfoDetailComponent
  },
  data () {
    return {
      AuditStateEnum: AuditStateEnum,
      submitLoading: false,
      readonly: false,
      expertState: ExpertState,
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      rules: {
        auditState: [{ required: true, message: "请选择是否同意", trigger: 'change' }],
      },
      modalVisible: false,
      expertInfo: {
        extras: {}
      },
      expertOutApplyFor: {},
      pendingAuditApplyForData: {}
    }
  },
  methods: {
    /**
     * 初始化数据
     * @param pendingAuditApplyForId 待审核申请表ID
     */
    async initData (pendingAuditApplyForId, readonly) {
      const res = await GetPendingAuditApplyForById(pendingAuditApplyForId)
      const result = res.result
      if (res.code == 200 && result) {
        this.pendingAuditApplyForData = result.pendingAuditApplyForData
        if (!readonly) {
          this.pendingAuditApplyForData.auditState = AuditStateEnum.APPROVE[0]
        }
        this.expertInfo = result.expertInfo
        this.expertOutApplyFor = result.expertOutApplyFor
        this.readonly = readonly
        this.modalVisible = true
      } else {
        this.$error({
          title: '此申请不存在',
        })
      }
    },
    onSubmitApplyFor () {
      this.$refs.auditForm.validate(valid => {
        if (valid) {
          this.handleSubmitApplyFor()
        } else {
          return false
        }
      })
    },
    async handleSubmitApplyFor () {
      this.submitLoading = true
      const res = await SubmitAuditApplyFor(this.pendingAuditApplyForData)
      if (res.code == 200) {
        this.$message.success('处理成功')
        this.modalVisible = false
        this.$emit("submitSuccess")
      }
      this.submitLoading = false
    },
    onClose () {
      this.modalVisible = false
    },
  },
}
</script>

<style lang="less" scoped>
.link {
  color: rgb(24, 144, 255);
}

.action button {
  margin-right: 4px;
}

.card {
  margin-bottom: 24px;

  .extras {
    font-weight: 500;
    font-size: 16px;
  }
}

.nav {
  .title {
    text-align: center;
    font-weight: 800;
  }

  .footer {
    text-align: right;
  }
}

.titleCap {
  margin-bottom: 12px;

  .receiveNum {
    padding-left: 16px;
  }

  > span {
    border-right: 1px solid #e6e6e6;
    padding: 0 20px;
  }

  > span:nth-last-child(1) {
    border-right: none;
  }

  > span:nth-child(2) {
    padding-left: 0;
  }
}
</style>